import { TState } from './types';
import { createReducer } from '@reduxjs/toolkit';
import {
  getDashboardItems,
  getCustomerCommunicationPaging,
  setCustomerCommunicationDashboardPageData,
  setNewEventName,
  getTextIntegrationSettings,
  getAvailablePhoneNumberList,
  setTextMessage,
  setEventForTextConfiguration,
  setEventIdForRulesConfiguration,
  setUpdatedEventsName,
  setCredits,
  setAvailableTagsForOutboundEvents,
  setAvailableTagsForRecallAlerts,
  setPlays,
  setUpdatedPlaysName,
  setPlaysPageData,
  setPlaysAudienceEditMode,
  setSelectedPlay,
} from './actions';
import { defaultPaging } from '../constants';

const initialState: TState = {
  dashboardItems: [],
  customerCommunicationPageData: {
    pageSize: 15,
    pageIndex: 0,
  },
  customerCommunicationPaging: { ...defaultPaging },
  playsPaging: { ...defaultPaging },
  newEventName: '',
  textIntegrationSettings: null,
  availablePhoneNumberList: [],
  textMessage: '',
  eventForTextConfiguration: null,
  eventIdForRulesConfiguration: null,
  updatedEventsName: [],
  credits: null,
  availableTagsForOutboundEvents: [],
  availableTagsForRecallAlerts: [],
  plays: [],
  updatedPlaysName: [],
  playsPageData: {
    pageSize: 10,
    pageIndex: 0,
  },
  playsAudienceEditMode: false,
  selectedPlay: null,
};

export const dealerOperationsReducer = createReducer<TState>(initialState, builder =>
  builder
    .addCase(getDashboardItems, (state, { payload }) => {
      return { ...state, dashboardItems: payload };
    })
    .addCase(setCustomerCommunicationDashboardPageData, (state, { payload }) => {
      return {
        ...state,
        customerCommunicationPageData: { ...state.customerCommunicationPageData, ...payload },
      };
    })
    .addCase(setPlaysPageData, (state, { payload }) => {
      return {
        ...state,
        playsPageData: { ...state.playsPageData, ...payload },
      };
    })
    .addCase(getCustomerCommunicationPaging, (state, { payload }) => {
      return { ...state, customerCommunicationPaging: payload };
    })
    .addCase(setNewEventName, (state, { payload }) => {
      return { ...state, newEventName: payload };
    })
    .addCase(getTextIntegrationSettings, (state, { payload }) => {
      return { ...state, textIntegrationSettings: payload };
    })
    .addCase(getAvailablePhoneNumberList, (state, { payload }) => {
      return { ...state, availablePhoneNumberList: payload };
    })
    .addCase(setTextMessage, (state, { payload }) => {
      return { ...state, textMessage: payload };
    })
    .addCase(setEventForTextConfiguration, (state, { payload }) => {
      return { ...state, eventForTextConfiguration: payload };
    })
    .addCase(setEventIdForRulesConfiguration, (state, { payload }) => {
      return { ...state, eventIdForRulesConfiguration: payload };
    })
    .addCase(setUpdatedEventsName, (state, { payload }) => {
      return { ...state, updatedEventsName: payload };
    })
    .addCase(setUpdatedPlaysName, (state, { payload }) => {
      return { ...state, updatedPlaysName: payload };
    })
    .addCase(setCredits, (state, { payload }) => {
      return { ...state, credits: payload };
    })
    .addCase(setAvailableTagsForOutboundEvents, (state, { payload }) => {
      return { ...state, availableTagsForOutboundEvents: payload };
    })
    .addCase(setAvailableTagsForRecallAlerts, (state, { payload }) => {
      return { ...state, availableTagsForRecallAlerts: payload };
    })
    .addCase(setPlays, (state, { payload }) => {
      return { ...state, plays: payload };
    })
    .addCase(setPlaysAudienceEditMode, (state, { payload }) => {
      return { ...state, playsAudienceEditMode: payload };
    })
    .addCase(setSelectedPlay, (state, { payload }) => {
      return { ...state, selectedPlay: payload };
    })
);
